var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5146 14L3.6946 12.818C4.0726 12.44 4.2806 11.938 4.2806 11.404V6.72702C4.2806 5.37002 4.8706 4.07302 5.9006 3.17102C6.9386 2.26102 8.2606 1.86102 9.6376 2.04202C11.9646 2.35102 13.7196 4.45502 13.7196 6.93702V11.404C13.7196 11.938 13.9276 12.44 14.3046 12.817L15.4856 14H2.5146ZM10.9996 16.341C10.9996 17.24 10.0836 18 8.9996 18C7.9156 18 6.9996 17.24 6.9996 16.341V16H10.9996V16.341ZM17.5206 13.208L15.7196 11.404V6.93702C15.7196 3.45602 13.2176 0.499016 9.8996 0.0600164C7.9776 -0.195984 6.0376 0.391016 4.5826 1.66702C3.1186 2.94902 2.2806 4.79302 2.2806 6.72702L2.2796 11.404L0.478603 13.208C0.00960291 13.678 -0.129397 14.377 0.124603 14.99C0.379603 15.604 0.972603 16 1.6366 16H4.9996V16.341C4.9996 18.359 6.7936 20 8.9996 20C11.2056 20 12.9996 18.359 12.9996 16.341V16H16.3626C17.0266 16 17.6186 15.604 17.8726 14.991C18.1276 14.377 17.9896 13.677 17.5206 13.208Z",
    fill: "#737687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications_icon.5036c454f655bd16f2f0c2ac0bd32c1f.svg";
export { ForwardRef as ReactComponent };